import { Button, Dropdown, Label } from "@heroui/react";
import { Columns3 } from "lucide-react";

/** The icon button above a table that turns columns on and off. */
export function ColumnsMenu({
  columns,
  visible,
  onChange,
}: {
  columns: Array<{ id: string; label: string }>;
  visible: Set<string>;
  onChange: (visible: Set<string>) => void;
}) {
  return (
    <Dropdown>
      <Button isIconOnly aria-label="Columns" variant="outline">
        <Columns3 className="size-4" />
      </Button>
      <Dropdown.Popover placement="bottom end">
        <Dropdown.Menu
          aria-label="Table columns"
          disallowEmptySelection
          selectedKeys={visible}
          selectionMode="multiple"
          onSelectionChange={(keys) =>
            onChange(new Set(Array.from(keys as Set<string>)))
          }
        >
          {columns.map((column) => (
            <Dropdown.Item
              key={column.id}
              id={column.id}
              textValue={column.label}
            >
              <Dropdown.ItemIndicator />
              <Label>{column.label}</Label>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown.Popover>
    </Dropdown>
  );
}
